import type { DayResponse, Location, TidesResponse } from "../shared/types.js";

export async function fetchLocations(): Promise<Location[]> {
  const resp = await fetch("/api/locations");
  if (!resp.ok) throw new Error(`GET /api/locations failed: ${resp.status}`);
  return resp.json();
}

export async function fetchTides(
  locationId: string,
  days: number
): Promise<TidesResponse> {
  const params = new URLSearchParams({
    locationId,
    days: String(days),
  });
  const resp = await fetch(`/api/tides?${params.toString()}`);
  if (!resp.ok) {
    const detail = await resp.text();
    throw new Error(`GET /api/tides failed: ${resp.status} ${detail}`);
  }
  return resp.json();
}

export async function fetchDay(
  locationId: string,
  date: string
): Promise<DayResponse> {
  const resp = await fetch(
    `/api/day/${encodeURIComponent(locationId)}/${encodeURIComponent(date)}`
  );
  if (!resp.ok) {
    const detail = await resp.text();
    throw new Error(`GET /api/day failed: ${resp.status} ${detail}`);
  }
  return resp.json();
}
